//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Flicking } from '@egjs/vue-flicking';
import { Arrow, AutoPlay, Pagination } from '@egjs/flicking-plugins';

export default {
  components: {
    Flicking,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    arrows: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Number,
      default: 0,
    },
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageCount: 1,
      prevClass: `flicking-arrow-prev-${this.id}`,
      nextClass: `flicking-arrow-next-${this.id}`,
      paginationClass: `flicking-pagination-${this.id}`,
    };
  },
  computed: {
    combinedOptions() {
      return {
        hideBeforeInit: true,
        align: 'prev',
        circular: true,
        noPanelStyleOverride: true,
        ...this.options,
      };
    },
  },
  mounted() {
    const { flicking } = this.$refs;

    flicking.on('ready', () => {
      this.initFlicking();
    });
    flicking.on('panelChange', () => {
      this.initFlicking();
    });
  },
  methods: {
    resizeFlickingCamera() {
      const { flicking } = this.$refs;
      flicking.resize();
      this.setPageCount();
    },
    setPageCount() {
      const { flicking } = this.$refs;

      if (flicking.camera.range.max === 0) {
        this.pageCount = 1;
      } else {
        this.pageCount = Math.ceil(flicking.camera.range.max / flicking.viewport.width);
      }
    },
    addDragStart() {
      const children = this.$el.querySelectorAll('.carousel-cell');

      children.forEach((el) => {
        el.ondragstart = function preventDrag() { return false; }; // eslint-disable-line no-param-reassign, max-len
      });
    },
    removeDragStart() {
      const children = this.$el.querySelectorAll('.carousel-cell');

      children.forEach((el) => {
        el.ondragstart = undefined; // eslint-disable-line no-param-reassign
      });
    },
    initFlicking() {
      const { flicking } = this.$refs;
      // hack to fix bad initial position
      const panel = flicking.getPanel(0);
      if (panel) {
        flicking.control.setActive(panel);
      }

      flicking.on('holdStart', this.addDragStart);

      flicking.on('holdEnd', this.removeDragStart);

      if (this.arrows) {
        flicking.addPlugins(
          new Arrow({
            parentEl: typeof document !== 'undefined' && document.body,
            prevElSelector: `.${this.prevClass}`,
            nextElSelector: `.${this.nextClass}`,
            moveByViewportSize: true,
          }),
        );
        flicking.resize();
        this.setPageCount();
      }
      if (this.autoplay > 0) {
        flicking.addPlugins(
          new AutoPlay({ duration: this.autoplay }),
        );
      }
      if (this.pagination) {
        flicking.addPlugins(
          new Pagination({
            type: 'bullet',
            parentEl: typeof document !== 'undefined' && document.body,
            selector: `.${this.paginationClass}`,
          }),
        );
      }
    },
  },
};
